<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>洗车监管系统</el-breadcrumb-item>
        <el-breadcrumb-item>结算中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'accountFinance' }">账户资金</el-breadcrumb-item>
        <el-breadcrumb-item>提现</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form style="width: 600px" ref="listForm" :model="listParams" label-width="120px">
        <el-form-item label="选择银行卡：" prop="bankcard">
          <div style="display: flex; flex-wrap: wrap" v-if="bankcardList.length > 0">
            <div class="bankcard-box mgl10 mgt10" :class="{ 'been-chosen': item.isChosen }" v-for="(item, index) in bankcardList" :key="index" @click="highlightBox(index)">
              <div class="triangle-border" v-if="item.isChosen">
                <span></span>
              </div>
              <p>{{ item.bankName }}</p>
              <p>{{ item.bankcard | formatBankcard }}</p>
            </div>
          </div>

          <div v-if="bankcardList.length === 0" class="add-dashed-btn" @click="bankListVisible = true">
            <i class="el-icon-plus"></i>
            <span>添加银行卡</span>
          </div>
          <div class="add-bankcard-box mgt10" v-if="bankListVisible === true">
            <el-form ref="bankcardListForm" style="width: 400px" :model="listParams.bankcardListParams" :rules="checkBankcardListParams" label-width="100px">
              <el-form-item label="开户单位：" prop="accountOpener">
                <el-input size="small" placeholder="请输入开户单位" v-model.trim="listParams.bankcardListParams.accountOpener"> </el-input>
              </el-form-item>

              <el-form-item class="mgt15" label="银行：" prop="bankId">
                <el-select
                  style="width: 100%"
                  size="small"
                  placeholder="请查询并选择银行"
                  filterable
                  remote
                  :loading="bankLoading"
                  :remote-method="remoteMethod"
                  v-model="listParams.bankcardListParams.bankId"
                >
                  <el-option v-for="item in bankList" :key="item.id" :value="item.id" :label="item.title"> </el-option>
                </el-select>
              </el-form-item>

              <el-form-item class="mgt15" label="开户城市：">
                <div style="display: flex">
                  <el-form-item prop="cityOpener.province">
                    <el-select style="width: 120px" size="small" placeholder="省" @change="loadCityList" v-model="listParams.bankcardListParams.cityOpener.province">
                      <el-option v-for="item in provinceList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item prop="cityOpener.city">
                    <el-select style="width: 120px; margin-left: 10px" size="small" placeholder="市" v-model="listParams.bankcardListParams.cityOpener.city">
                      <el-option v-for="item in cityList" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form-item>

              <el-form-item class="mgt15" label="开户网点：" prop="branchOpener">
                <el-input size="small" placeholder="请输入开户网点" v-model.trim="listParams.bankcardListParams.branchOpener"> </el-input>
              </el-form-item>

              <el-form-item class="mgt15" label="银行卡号：" prop="bankcard">
                <el-input :maxlength="23" size="small" placeholder="请输入银行卡号" v-model="listParams.bankcardListParams.bankcard"> </el-input>
              </el-form-item>

              <el-form-item label=" " class="mgt15">
                <el-button style="width: 120px" size="small" @click="closeAndResetForm('bankcardListForm')"> 取 消 </el-button>

                <el-button :disabled="bankBtnDisabled" style="width: 120px" size="small" type="primary" @click="addBankcard('bankcardListForm')"> 添 加 </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-form-item>

        <el-form-item label="可提现金额：" prop="amount">
          <span class="alert-text">
            {{ listParams.amount }}
          </span>
          元
        </el-form-item>

        <el-form-item label="提现金额：" prop="withdrawAmount">
          <el-input size="small" v-model="listParams.withdrawAmount" placeholder="请输入提现金额">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="手续费：" prop="serviceCharge">
          <span class="alert-text">
            {{ listParams.serviceCharge }}
          </span>
          元
        </el-form-item>

        <el-form-item label="联系方式：" prop="tel">
          <el-input size="small" v-model="listParams.tel" @blur="checkTel" :maxlength="11" placeholder="请输入负责人联系方式"> </el-input>
        </el-form-item>

        <el-form-item label=" ">
          <el-button :disabled="isDisabled" size="small" style="width: 200px" type="primary" @click="formatWithdraw"> 提 现 </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog class="hx-to-create-template" title="请确认提现信息" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" label-width="120px">
          <el-form-item label="提现金额：">
            <span class="alert-text">{{ itemParams.withdrawAmount }}</span> 元
          </el-form-item>

          <el-form-item label="手续费：">
            <span class="alert-text">{{ itemParams.serviceCharge }}</span> 元
          </el-form-item>

          <el-form-item label="实际金额：">
            <span class="alert-text">{{ itemParams.actualAmount }}</span> 元
          </el-form-item>

          <el-form-item label="所属银行：">
            {{ itemParams.bankName }}
          </el-form-item>

          <el-form-item label="银行卡号：">
            {{ itemParams.bankcard }}
          </el-form-item>

          <el-form-item label="联系方式：">
            {{ itemParams.tel }}
          </el-form-item>

          <el-form-item label=" ">
            <el-button style="width: 80px" size="small" @click="dialogVisible = false"> 取 消 </el-button>

            <el-button style="width: 80px" size="small" type="primary" :disabled="withdrawDisabled" @click="withdraw"> 提 现 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    const checkIsNum = function (rule, value, callback) {
      if (value) {
        if (!/^[\d\s]+$/.test(value)) {
          callback(new Error("银行卡格式错误"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入银行卡号"));
      }
    };
    return {
      listParams: {
        bankcardListParams: {
          accountOpener: "",
          bankId: "",
          cityOpener: {
            province: "",
            city: "",
          },
          branchOpener: "",
          bankcard: "",
        },
        amount: 0,
        withdrawAmount: "",
        serviceCharge: 0,
        tel: "",
      },
      bankcardList: [], // 银行卡列表
      copyBankcardList: [], // 银行卡列表副本
      checkBankcardListParams: {
        accountOpener: [{ required: true, message: "请输入开户单位", trigger: "blur" }],
        bankId: [{ required: true, message: "请查询并选择银行", trigger: "change" }],
        "cityOpener.province": [{ required: true, message: "请选择省", trigger: "change" }],
        "cityOpener.city": [{ required: true, message: "请选择市", trigger: "change" }],
        branchOpener: [{ required: true, message: "请输入开户网点", trigger: "blur" }],
        bankcard: [{ required: true, message: "请输入银行卡号", trigger: "blur" }, { validator: checkIsNum }],
      },
      bankListVisible: false,
      bankLoading: false,
      bankBtnDisabled: false,
      bankList: [], // 银行列表
      provinceList: [],
      cityList: [],
      isChosen: false, // 银行卡是否被选中
      isDisabled: false,
      dialogVisible: false,
      itemParams: {
        // 提现请求信息
        withdrawAmount: 0,
        serviceCharge: 0,
        actualAmount: 0,
        bankName: "",
        bankcard: "",
        bankId: "",
        tel: "",
      },
      withdrawDisabled: false,
    };
  },
  mounted() {
    // url中可提现金额赋值
    this.listParams.amount = this.$route.query.withdrawAmount;
    this.loadBankcardList();
    this.loadProvinceList();
    this.setHighlightBox(0);
  },
  methods: {
    /**
     * 初始化加载银行卡列表
     */
    loadBankcardList() {
      this.$http({
        url: global.apiUrl + "/settlement/bankcardList",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.bankcardList = res.body.data;
          } else {
            this.bankcardList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 设置高亮银行卡box
     * @param key
     */
    setHighlightBox(key) {
      this.bankcardList.map((item, index) => {
        Vue.set(item, "isChosen", false);
        if (index === key) {
          Object.assign(item, { isChosen: true });
          this.itemParams.bankName = item.bankName;
          this.itemParams.bankcard = this.copyBankcardList[index].bankcard;
          this.itemParams.bankId = item.bankId;
        } else {
          Object.assign(item, { isChosen: false });
        }
      });
    },
    /**
     * 远程查询银行
     * @param query
     */
    remoteMethod(query) {
      this.$http({
        url: global.apiUrl + "/settlement/bankList?query=" + query,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.bankList = res.body.data;
          } else {
            this.bankList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化加载省份列表
     */
    loadProvinceList() {
      this.$http({
        url: global.apiUrl + "/settlement/provinceList",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.provinceList = res.body.data;
          } else {
            this.provinceList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 联动加载城市列表
     * @param query
     */
    loadCityList(query) {
      this.cityList = [];
      this.$http({
        url: global.apiUrl + "/settlement/cityList?provinceId=" + query,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.cityList = res.body.data;
          } else {
            this.cityList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 高亮选中box
     * @param i
     */
    highlightBox(i) {
      this.bankcardList.map((item, index) => {
        if (index === i) {
          item.isChosen = true;
          // 选中银行卡时，将选中的银行卡信息赋值给itemParams
          this.itemParams.bankName = item.bankName;
          this.itemParams.bankcard = item.bankcard;
          this.itemParams.bankId = item.bankId;
        } else {
          item.isChosen = false;
        }
      });
    },
    /**
     * 关闭并重置表单
     * @param name
     */
    closeAndResetForm(name) {
      this.bankListVisible = false;
      this.$refs[name].resetFields();
    },
    /**
     * 添加银行卡
     * @param name
     */
    addBankcard(name) {
      this.bankBtnDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.bankBtnDisabled = false;
          const bodyParams = Object.assign({}, this.listParams.bankcardListParams);
          this.$http({
            url: global.apiUrl + "/settlement/bankcard",
            method: "POST",
            body: bodyParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.loadBankcardList();
                this.bankListVisible = false;
              } else {
              }
            })
            .catch(err => {
              console.error(err);
            });
          // 添加银行卡成功后将高亮新增的银行卡
          this.setHighlightBox(this.bankcardList.length);
        } else {
          this.bankBtnDisabled = false;
        }
      });
    },
    /**
     * 电话正则验证
     * @param e
     */
    checkTel(e) {
      if (/[^0-9-]+/.test(e.target.value)) {
        this.$message.warning("请输入正确的电话格式");
        this.listParams.tel = "";
      }
    },
    /**
     * 提现验证
     */
    formatWithdraw() {
      this.isDisabled = true;
      let flag = false;
      const listParams = this.listParams;
      if (isNaN(parseFloat(listParams.withdrawAmount))) {
        this.$message.warning("请输入正确的提现金额");
        this.isDisabled = false;
        listParams.withdrawAmount = "";
        return;
      }
      // 将所填写的信息赋值到itemParams中
      Object.assign(this.itemParams, {
        withdrawAmount: parseFloat(listParams.withdrawAmount),
        serviceCharge: listParams.serviceCharge,
        tel: listParams.tel,
      });
      const bodyParams = Object.assign({}, this.itemParams, {
        tel: listParams.tel,
      });
      for (const i in bodyParams) {
        if (bodyParams[i] === "" || bodyParams[i] === 0) {
          this.$message.error("请正确填写需提现的信息后再提交");
          flag = false;
          break;
        } else {
          flag = true;
        }
      }
      this.isDisabled = false;
      if (flag) {
        this.dialogVisible = true;
      }
    },
    /**
     * 提现
     */
    withdraw() {
      this.withdrawDisabled = true;
      const bodyParams = Object.assign({}, this.itemParams);
      bodyParams.actualAmount = parseFloat(bodyParams.actualAmount);
      bodyParams.serviceCharge = parseFloat(bodyParams.serviceCharge);
      this.$http({
        url: global.apiUrl + "/settlement/withdraw",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.$router.push({
              name: "accountFinance",
            });
          } else {
            this.withdrawDisabled = false;
          }
        })
        .catch(err => {
          this.withdrawDisabled = false;

          console.error(err);
        });
    },
    /**
     * 只能输入数字且不能大于两位小数
     * @param val
     * @returns {boolean}
     */
    checkReg(val) {
      const reg = /^\d+(\.\d{1,2})?$/;
      if (reg.test(parseFloat(val))) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    "listParams.bankcardListParams.bankcard": function (val, oldVal) {
      if (val) {
        // 输入四位自动加空格
        this.listParams.bankcardListParams.bankcard = val.replace(/[\s]/g, "").replace(/(\d{4})(?=\d)/g, "$1 ");
      }
    },
    "listParams.withdrawAmount": function (val, oldVal) {
      if (val !== "" && parseFloat(val) !== 0) {
        if (parseFloat(val) > parseFloat(this.listParams.amount)) {
          this.$message.warning("提现金额不能超过可提现金额");
          this.listParams.withdrawAmount = this.listParams.amount;
          return;
        }
        if (!isNaN(parseFloat(val)) && this.checkReg(val)) {
          this.listParams.withdrawAmount = parseFloat(val);
          this.$http({
            url: global.apiUrl + "/settlement/calculateTransferFee?query=" + parseFloat(val),
            method: "GET",
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.listParams.serviceCharge = res.body.data.serviceCharge;
                this.itemParams.actualAmount = res.body.data.actualAmount;
              } else {
                this.listParams.serviceCharge = 0;
                this.itemParams.actualAmount = 0;
              }
            })
            .catch(err => {
              console.error(err);
            });
        } else {
          this.$message.warning("请输入正确的提现金额");
          this.listParams.serviceCharge = 0;
          this.itemParams.actualAmount = 0;
        }
      } else {
        this.listParams.withdrawAmount = "";
        this.listParams.serviceCharge = 0;
        this.itemParams.actualAmount = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
  .hx-form-container {
    .add-dashed-btn {
      width: 200px;
      height: 80px;
      border: 1px #b4bccc dashed;
      border-radius: 5px;
      color: #b4bccc;
      line-height: 80px;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
    }
    .add-dashed-btn:hover {
      color: teal;
      border-color: teal;
    }
    .bankcard-list-style {
      width: 200px;
      height: 50px;
      border: 1px teal solid;
    }
    .bankcard-box {
      position: relative;
      cursor: pointer;
      width: 200px;
      height: 80px;
      border: 1px #b4bccc solid;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      color: #b4bccc;
      .triangle-border {
        width: 0;
        height: 0;
        border-width: 30px 0 0 30px;
        border-style: solid;
        border-color: teal transparent transparent transparent;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .been-chosen {
      border: 1px teal solid;
      color: #000000;
    }
    .add-bankcard-box {
      border: 1px teal dashed;
      border-radius: 5px;
      padding: 10px 10px;
    }
  }
}
</style>
